import angular from 'angular';
import moment from 'moment';

angular.module('cloudX').directive('cxExternalServiceLink', [
  function() {
    return {
      restrict: 'E',
      template: `<a href="javascript:void(0);" ng-click="handleClick()" class="margin10R" title="{{tooltip}}" ng-if="imageAvailable">
                   <img style="height:25px;" ng-src="{{imgSource}}" alt="{{tooltip}}" clear-image-on-error/>
                 </a>`,
      scope: {
        value: '=',
        relation: '=',
      },
      controller: [
        '$rootScope',
        '$scope',
        '$http',
        'appUrls',
        '$translate',
        '$timeout',
        'translateListFilter',
        function($rootScope, $scope, $http, appUrls, $translate, $timeout, translateListFilter) {
          $scope.imageAvailable = true;
          $scope.hide = () => {
            $timeout(() => {
              $scope.imageAvailable = false;
            }, 0);
          };
          $scope.handleClick = async function() {
            const businessNumberFieldId = '11cbb373-2ad8-496f-872f-f4a4be31b9a5';
            const vatNumberFieldId = 'dfd0fd1c-8c4d-4e9e-be98-a79f26310960';
            const kvkNumberFieldId = 'c7cc236a-1c66-4d35-88d9-ca8bb27872f2';
            const nationalIdNumberFieldId = '3b8e7746-100e-4e5c-930b-4de7628a574b';
            const nameFieldId = 'ccb058e7-f972-4215-82f1-0efdd16deb7d';

            let businessNumberValue = '';
            let vatNumberValue = '';
            let kvkNumberValue = '';
            let nationalIdNumberValue = '';
            let nameValue = '';

            if ($scope.relation && $scope.relation[businessNumberFieldId]) {
              businessNumberValue = $scope.relation[businessNumberFieldId].value;
            }
            if ($scope.relation && $scope.relation[vatNumberFieldId]) {
              vatNumberValue = $scope.relation[vatNumberFieldId].value;
            }
            if ($scope.relation && $scope.relation[kvkNumberFieldId]) {
              kvkNumberValue = $scope.relation[kvkNumberFieldId].value;
            }
            if ($scope.relation && $scope.relation[nationalIdNumberFieldId]) {
              nationalIdNumberValue = $scope.relation[nationalIdNumberFieldId].value;
            }
            if ($scope.relation && $scope.relation[nameFieldId]) {
              nameValue = $scope.relation[nameFieldId].value;
            }

            const params = {
              relationType: $scope.relation.type,
              enterpriseNr: businessNumberValue,
              kvkNumber: kvkNumberValue,
              vatNumber: vatNumberValue,
              nationalIdNumber: nationalIdNumberValue,
              name: nameValue,
              externalServiceLinkType: $scope.value.type,
              externalServiceLinkValue: $scope.value.metadata,
              metadata: $scope.value.metadata,
            };

            try {
              const response = await $http.get(
                `${appUrls.connectRelationsApi}/api/externallink/${$scope.relation.companyId}/${$scope.relation.id}`,
                { params },
              );
              $scope.url = response.data || '';
            } catch (error) {
              console.error('Error fetching external link:', error);
            }

            if ($scope.url) {
              const lang = $translate
                .use()
                .toLowerCase()
                .split('-')[0];
              $scope.url = $scope.url.replace('{lang}', lang);
              window.open($scope.url, '_blank');
            }
          };

          var generateUrl = function() {
            $scope.url = '';
            $scope.imgSource = '';
            $scope.tooltip = '';

            $scope.tooltip = translateListFilter($scope.value.type, 'ExternalServiceLinkType', '');

            // different logos in separate folder per social secretariat
            if ($scope.value && $scope.value.type === 6 && $scope.value.metadata) {
              const socialSecretariat = parseInt($scope.value.metadata);
              $scope.imgSource = `https://static.adminpulse.eu/public/images/external-links/social-secretariats/${socialSecretariat}.png`;
              $scope.tooltip = `${$scope.tooltip}: ${translateListFilter(
                socialSecretariat,
                'SocialSecretariat',
                '',
              )}`;
            } else if ($scope.value && $scope.value.type === 7 && $scope.value.metadata) {
              const socialSecurityFund = parseInt($scope.value.metadata);
              $scope.imgSource = `https://static.adminpulse.eu/public/images/external-links/social-security-funds/${socialSecurityFund}.png`;
              $scope.tooltip = `${$scope.tooltip}: ${translateListFilter(
                socialSecurityFund,
                'SocialSecurityFund',
                '',
              )}`;
            } else if ($scope.value && $scope.value.type === 10 && $scope.value.metadata) {
              const accountingSoftware = parseInt($scope.value.metadata);
              $scope.imgSource = `https://static.adminpulse.eu/public/images/external-links/accounting-softwares/${accountingSoftware}.png`;
              $scope.tooltip = `${$scope.tooltip}: ${translateListFilter(
                accountingSoftware,
                'AccountingSoftware',
                '',
              )}`;
            } else if ($scope.value && $scope.value.type === 11 && $scope.value.metadata) {
              const otherSoftware = parseInt($scope.value.metadata);
              $scope.imgSource = `https://static.adminpulse.eu/public/images/external-links/other-softwares/${otherSoftware}.png`;
              $scope.tooltip = `${$scope.tooltip}: ${translateListFilter(
                otherSoftware,
                'OtherSoftware',
                '',
              )}`;
            } else if ($scope.value && $scope.value.type === 17 && $scope.value.metadata) {
              const sendInvoiceSoftware = parseInt($scope.value.metadata);
              $scope.imgSource = `https://static.adminpulse.eu/public/images/external-links/send-invoice-softwares/${sendInvoiceSoftware}.png`;
              $scope.tooltip = `${$scope.tooltip}: ${translateListFilter(
                sendInvoiceSoftware,
                'sendInvoiceSoftware',
                '',
              )}`;
            } else if ($scope.value && $scope.value.type === 18 && $scope.value.metadata) {
              const receiveInvoiceSoftware = parseInt($scope.value.metadata);
              $scope.imgSource = `https://static.adminpulse.eu/public/images/external-links/receive-invoice-softwares/${receiveInvoiceSoftware}.png`;
              $scope.tooltip = `${$scope.tooltip}: ${translateListFilter(
                receiveInvoiceSoftware,
                'receiveInvoiceSoftware',
                '',
              )}`;
            } else {
              $scope.imgSource = `https://static.adminpulse.eu/public/images/external-links/${$scope.value.type}.png`;
            }
          };

          generateUrl();

          var deregistration = $rootScope.$on('$translateChangeSuccess', generateUrl);
          $scope.$on('$destroy', deregistration);
        },
      ],
    };
  },
]);
